import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Button, Text, TextTypes, Input, showLoader, showToast, ToastVariants } from '../index';
import Service from '../../services/apolloClient.service';

const apolloService = new Service();

interface ClaimAccessFormProps {
    carddetid: number;
    clientcardsrno: string;
    onSuccess: () => void;
}

const ClaimAccessForm = ({ carddetid, clientcardsrno, onSuccess }: ClaimAccessFormProps) => {
    const [email, setEmail] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const res: any = await showLoader(apolloService.claimCardAccess(clientcardsrno, carddetid, email));

        if (res?.status === 0 && res.token) {
            // Key by (carddetid, clientcardsrno) so tokens for different cards
            // in separate tabs never overwrite each other.
            sessionStorage.setItem(`card_token:${carddetid}:${clientcardsrno}`, res.token);
            showToast({
                title: 'Success!',
                content: 'Access granted.',
                variant: ToastVariants.SUCCESS,
            });
            onSuccess();
        } else {
            showToast({
                title: 'Verification Failed',
                content: 'The email address provided does not match our records for this gift card.',
                variant: ToastVariants.DANGER,
            });
        }
    };

    return (
        <Container className="mt-5 mb-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <Text type={TextTypes.H3} className="mb-4">Verification Required</Text>
                    <Text type={TextTypes.P} className="mb-4">
                        To protect your security, please enter the email address this gift card was sent to.
                    </Text>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-4">
                            <Input
                                type="email"
                                placeholder="Enter email address"
                                value={email}
                                onChange={(e: any) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                        {/* No-op onClick: the native <button> inside <Form> defaults to
                            type="submit", so submission is driven exclusively by Form.onSubmit
                            (handleSubmit). spoton-lib Button requires onClick as a prop. */}
                        <Button className="w-100" onClick={() => {}}>
                            Verify Email
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default ClaimAccessForm;
